import { createStyles } from '@material-ui/styles';

const styles = (): any =>
    createStyles({
        root: {},
        subFormDetails: {
            width: '33%',
            height: '37vh',
        },
    });

export default styles;
